import { render, staticRenderFns } from "./PaymentProfileSection.vue?vue&type=template&id=2f60bafa&"
import script from "./PaymentProfileSection.vue?vue&type=script&lang=ts&"
export * from "./PaymentProfileSection.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentProfileSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports